import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as React from 'react';
import { useFileInputContext } from './file-input.context.js';
import { Button, buttonPropTypes } from '../button/button.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var propTypes = _object_spread({}, buttonPropTypes);

var propKeysToRemove = Object.keys(propTypes);
var FileInputLabel = renderWithRef('FileInputLabel', propTypes, function (props, ref) {
  var classNames = new Set(['']);
  var children = props.children,
      skin = props.skin,
      size = props.size,
      width = props.width,
      specialVariant = props.specialVariant,
      iconPosition = props.iconPosition,
      buttonShape = props.buttonShape;

  var _useFileInputContext = useFileInputContext(),
      inputId = _useFileInputContext.inputId,
      disabled = _useFileInputContext.disabled;

  return /*#__PURE__*/React.createElement(Button, {
    skin: skin,
    size: size,
    width: width,
    specialVariant: specialVariant,
    iconPosition: iconPosition,
    buttonShape: buttonShape,
    render: function render(_ref) {
      var className = _ref.className;
      return /*#__PURE__*/React.createElement(RenderComp, {
        root: "label",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: new Set([].concat(_toConsumableArray(classNames), ['swan-file-input-label', className !== null && className !== void 0 ? className : ''])),
        props: _object_spread_props(_object_spread({}, props), {
          htmlFor: inputId,
          'aria-disabled': disabled
        })
      }, children);
    }
  });
});
export { FileInputLabel };